import { mount } from 'svelte'
import App from './App.svelte'
import './app.css'
import './signs.css'

const target = document.getElementById('app')
if (!target) throw new Error('missing #app')
mount(App, { target })
